import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Commons } from 'components';

import * as usg_action from 'actions/usage';

import cm from 'helpers/commons';

class StatsList extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    let result = true;

    if (JSON.stringify(nextProps.dateType) !== JSON.stringify(this.props.dateType)) {
      result = false;
    }

    return result;
  }
  render() {
    const { usageStat, usageStatsTotal, sort, dateType } = this.props,
      { page, pagerow, pageClick } = this.props.listFn;

    const tabledata = {
      header: {
        main: [
          { data: '식사 인원수', textAlign: 'right' },
          { data: '식사 횟수', textAlign: 'right' },
          { data: '결제 횟수', textAlign: 'right' },
          { data: '회사식대', textAlign: 'right' },
          { data: '정산금액', textAlign: 'right' }
        ]
      },
      body: {
        message: '식사 사용 통계 내역이 존재하지 않습니다.',
        main: null
      }
    };

    let p_page = page,
      p_pagerow = pagerow,
      totalcount = 0;

    const totalData = {
      companyprice: 0,
      couponcount: 0,
      couponmember: 0,
      paycount: 0,
      salesprice: 0,
      companySupportPrice: 0,
      salaryDeductionPrice: 0
    };

    if (usageStat) {
      if (usageStat.data) {
        const { paging, table, stat, depth } = usageStat.data;

        if (table && table.length > 0) {
          tabledata.header.main = [];
          table.forEach((data, idx) => {
            tabledata.header.main.push({
              data: data.name,
              textAlign: 'right'
            });
          });
        }

        if (paging) {
          p_page = paging.page;
          p_pagerow = paging.pagerow;
          totalcount = paging.totalcount;
        }

        //헤더 타이틀
        let colSpan = 1;

        if (table && table.length > 0) {
          colSpan = table.length;

          let header_title = table.map((item) => {
            let textAlign = 'left';
            if (['couponmember', 'couponcount', 'paycount', 'salesprice', 'companyprice', 'companySupportPrice', 'salaryDeductionPrice'].indexOf(item.property) > -1) {
              textAlign = 'right';
              colSpan--;
            }

            let obj = {
              data: item.name,
              textAlign: textAlign
            };
            return obj;
          });
          tabledata.header.main = header_title;
        }

        //헤더 서브 타이틀
        if (usageStatsTotal && usageStatsTotal.data) {
          const { total } = usageStatsTotal.data;

          totalData['companyprice'] = total.companyprice;
          totalData['couponcount'] = total.couponcount;
          totalData['couponmember'] = total.couponmember;
          totalData['paycount'] = total.paycount;
          totalData['salesprice'] = total.salesprice;
          totalData['companySupportPrice'] = total.companySupportPrice;
          totalData['salaryDeductionPrice'] = total.salaryDeductionPrice;

          tabledata.header.sub = [
            {
              data: '합계',
              colSpan: colSpan,
              textAlign: 'left'
            }
          ];

          table.forEach((item) => {
            switch (item.name) {
              case '식사인원수':
                tabledata.header.sub.push({
                  data: cm.numberComma(totalData['couponmember']),
                  textAlign: 'right'
                });
                break;
              case '식사횟수':
                tabledata.header.sub.push({
                  data: cm.numberComma(totalData['couponcount']),
                  textAlign: 'right'
                });
                break;
              case '결제횟수':
                tabledata.header.sub.push({
                  data: cm.numberComma(totalData['paycount']),
                  textAlign: 'right'
                });
                break;
              case '회사식대':
                tabledata.header.sub.push({
                  data: cm.numberComma(totalData['salesprice']),
                  textAlign: 'right'
                });
                break;
              case '정산금액':
                tabledata.header.sub.push({
                  data: cm.numberComma(totalData['companyprice']),
                  textAlign: 'right'
                });
                break;
              case '회사지원금액':
                tabledata.header.sub.push({
                  data: cm.numberComma(totalData['companySupportPrice']),
                  textAlign: 'right'
                });
                break;
              case '급여공제금액':
                tabledata.header.sub.push({
                  data: cm.numberComma(totalData['salaryDeductionPrice']),
                  textAlign: 'right'
                });
                break;
              default:
            }
          });
        }

        //리스트 내용
        if (stat && stat.length > 0) {
          tabledata.body.main = stat.map((item) => {
            let obj = {
              row: []
            };

            let headerType = null;

            tabledata.header.main.forEach((header, idx) => {
              switch (header.data) {
                case '날짜':
                  obj.row.push({ data: item.sdate, textAlign: 'left' });
                  break;
                case 'ID':
                  obj.row.push({ data: item.signid, textAlign: 'left' });
                  break;
                case '이름':
                  obj.row.push({ data: item.username, textAlign: 'left' });
                  headerType = 'name';
                  break;
                case '사번':
                  obj.row.push({ data: item.comidnum, textAlign: 'left' });
                  break;
                case '부서1':
                  headerType = !headerType ? 'division' : headerType;
                  break;
                case '가맹점명':
                  obj.row.push({ data: item.storename, textAlign: 'left' });
                  break;
                case '식대그룹':
                  obj.row.push({ data: item.groupname, textAlign: 'left' });
                  break;
                case '식대정책':
                  obj.row.push({ data: item.policyname, textAlign: 'left' });
                  break;
                case '부서수':
                  obj.row.push({
                    data: cm.numberComma(item.divisioncount),
                    textAlign: 'left'
                  });
                  break;
                case '식사인원수':
                  obj.row.push({
                    data: cm.numberComma(item.couponmember),
                    textAlign: 'right'
                  });
                  break;
                case '식사횟수':
                  obj.row.push({
                    data: cm.numberComma(item.couponcount),
                    textAlign: 'right'
                  });
                  break;
                case '결제횟수':
                  obj.row.push({
                    data: cm.numberComma(item.paycount),
                    textAlign: 'right'
                  });
                  break;
                case '회사식대':
                  obj.row.push({
                    data: cm.numberComma(item.salesprice),
                    textAlign: 'right'
                  });
                  break;
                case '정산금액':
                  obj.row.push({
                    data: cm.numberComma(item.companyprice),
                    textAlign: 'right'
                  });
                  break;
                case '회사지원금액':
                  obj.row.push({
                    data: cm.numberComma(item.companySupportPrice),
                    textAlign: 'right'
                  });
                  break;
                case '급여공제금액':
                  obj.row.push({
                    data: cm.numberComma(item.salaryDeductionPrice),
                    textAlign: 'right'
                  });
                  break;
                default:
              }

              return;
            });

            let isDateTypeSum = false;
            if (dateType && dateType.value) {
              isDateTypeSum = dateType.value === 'SUM' ? true : false;
            }

            let start = 0;
            if (headerType === 'division') {
              start = 1;

              if (isDateTypeSum) {
                start -= 1;
              }

              obj = cm.defalutTableStaffDivisionSet(obj.row, start, null, depth, item.fullname);
            } else if (headerType === 'name') {
              start = 4;

              if (isDateTypeSum) {
                start -= 1;
              }

              obj = cm.defalutTableStaffDivisionSet(obj.row, start, null, depth, item.fullname);
            }
            return obj;
          });
        }
      } else {
        if (usageStat.response) {
          tabledata.body.message = usageStat.response.data.message;
        }
      }
    }

    return (
      <div>
        <div className="table-box">
          <Commons.TableForm tabledata={tabledata} />
        </div>

        <div className="table-paging">
          <Commons.Pagination
            page={p_page}
            pageRow={p_pagerow}
            pageBlock={10}
            totalCount={totalcount}
            pageClick={pageClick}
          />
        </div>
      </div>
    );
  }
}

StatsList = connect((state) => ({
  usageStat: state.usage.usageStats,
  usageStatsTotal: state.usage.usageStatsTotal,
  dateType: state.commons.dateType
}))(StatsList);

export default StatsList;
